import { type ButtonHTMLAttributes, type ReactNode } from 'react'

import { useLocation } from 'react-router'

import { Icon } from '@/components/icon'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/infra'
import type { TProduto } from '@/types/produto'
import { obterConfiguracaoProduto } from '@/utils/status-config'

interface IAcessorioCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  produto: TProduto
  nomeAgrupador: string
  handleSelecionarProduto: (produto: TProduto, nomeVaga: string) => void
  isSelected: boolean
  tooltip?: ReactNode
}

export const ProdutoCard = ({
  produto,
  isSelected,
  handleSelecionarProduto,
  tooltip,
  nomeAgrupador,
  className,
  ...props
}: IAcessorioCardProps) => {
  const { pathname } = useLocation()
  const variant = obterConfiguracaoProduto(pathname)[produto.tipoLegendaStatus].variant

  const onCardClick = () => {
    handleSelecionarProduto(produto, nomeAgrupador)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          data-selected={isSelected}
          data-status={produto.status}
          className={cn(
            'font-nunito text-md relative flex min-h-20 w-full grow basis-1/7 cursor-pointer items-center justify-center rounded-md border p-2 text-center font-semibold duration-250 hover:-translate-y-0.5',
            className,
          )}
          variant={variant}
          asChild
        >
          <button type="button" onClick={onCardClick} {...props}>
            <span className="overflow-hidden text-wrap wrap-break-word">{produto.descricao}</span>
            {produto.altaProcura && (
              <div className="absolute right-2 bottom-2">
                <Icon
                  data-selected={isSelected}
                  name="flame"
                  className="text-destructive data-[selected=true]:text-red-500"
                />
              </div>
            )}
          </button>
        </Badge>
      </TooltipTrigger>
      {!!tooltip && (
        <TooltipContent side="top" sideOffset={-5}>
          {tooltip}
        </TooltipContent>
      )}
    </Tooltip>
  )
}
